import { deprecated } from "../../common/logger";
import { assignNamespace } from "../../common/assignNamespace";
import { o_util } from "../../common/namespaces";
import { easings } from "./easings";
import { fadeIn, fadeOut } from "./fade";
import { scrollTo } from "./scrollTo";
import { transition, transitions } from "./transition";

export { easings } from "./easings";
export type { EasingFunc, Easings } from "./easings";
export { fadeIn, fadeOut } from "./fade";
export { scrollTo } from "./scrollTo";
export { transition, transitions } from "./transition";

assignNamespace(o_util, "animation", {
  easings,
  fadeIn: deprecated(fadeIn, "animation", "fadeIn", "use native CSS transitions instead"),
  fadeOut: deprecated(fadeOut, "animation", "fadeOut", "use native CSS transitions instead"),
  scrollTo: deprecated(
    scrollTo,
    "animation",
    "scrollTo",
    "use native Element.scrollIntoView or Window.scrollTo instead",
  ),
  transition: deprecated(
    transition,
    "animation",
    "transition",
    "use native CSS transitions instead",
  ),
  transitions,
});
